import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import SecondaryNav from '../../secondary-nav/secondary-nav';
import MetricsFramework from '../../key-metrics/metrics-framework';
import SubHeader from '../sub-header/sub-header';
import HorizontalTable from '../../horizontal-table/horizontal-table';

const GcProfileContainer = ({ children, className }) => {
  return (
    <div data-testid="profile-container" className={className}>
      {children}
    </div>
  );
};

const StyledGcProfileContainer = styled(GcProfileContainer)`
  overflow-x: auto;
  ${HorizontalTable}, ${SubHeader}, ${SecondaryNav}, ${MetricsFramework} {
    width: 100%;
    min-width: 90rem;
  }

  @media screen and (min-width: 90rem) {
    overflow: initial;
    ${HorizontalTable}, ${SubHeader}, ${SecondaryNav}, ${MetricsFramework} {
      width: 100%;
      max-width: ${vars.contentMaxWidth};
    }
  }

  ${SecondaryNav} {
    a {
      &:hover {
        color: white;
        background-color: ${vars.plasticsBlue};
        cursor: pointer;
      }
    }
  }
`;

export default StyledGcProfileContainer;
